
import { useState } from 'react';
import { useLikeState } from './hooks/useLikeState';
import { useProfilePath } from './hooks/useProfilePath';
import { useHoverState } from './hooks/useHoverState';

interface UseDesignerCardStateProps {
  id: string;
  isLiked: boolean;
  likeCount: number;
  username_slug?: string | null;
  user?: any | null;
}

export const useDesignerCardState = ({
  id,
  isLiked,
  likeCount,
  username_slug,
  user = null
}: UseDesignerCardStateProps) => {
  const { likeState, localLikeCount, handleLikeToggle, handleMobileLike, isLoading } = useLikeState({
    id,
    isLiked,
    likeCount,
    user
  });
  
  const { profilePath } = useProfilePath({
    id,
    username_slug
  });
  
  const { isHovered, setIsHovered } = useHoverState();

  return {
    likeState,
    likeCount: localLikeCount,
    handleLikeToggle,
    handleMobileLike,
    isLoading,
    profilePath,
    isHovered,
    setIsHovered
  };
};
